import { Spinner } from 'react-bootstrap';

export default function loadingSpinner() {
  return <Spinner animation="border" variant="primary" role="status" />;
}
